import { type AssetCategory, type DataType, type ICriteria } from '@inpart-io/padme-iap';

const FIELDS_MANAGEMENT_PREFIX = 'fields_management_';

export function getModuleKey(criteria: string): string {
    return `${FIELDS_MANAGEMENT_PREFIX}${criteria.toString()}`;
}

export function getCriteriaList(criteria: ICriteria[]): string[] {
    return criteria.map((c) => {
        return `${c.attribute}:${c.values.join(',')}`;
    });
}

export function getCriteriaKey(dataType: DataType, dealTypeId: string, additionalCriteria?: ICriteria[]): string {
    let criteriaKey = '';
    const filteredAdditionalCriteria = additionalCriteria?.filter((c) => {
        return c.attribute !== 'dealType';
    });
    if (filteredAdditionalCriteria && filteredAdditionalCriteria.length > 0) {
        const orderedAdditionalCriteria = filteredAdditionalCriteria.sort((a, b) => {
            if (a.attribute < b.attribute) return -1;
            if (a.attribute > b.attribute) return 1;
            return 0;
        });
        criteriaKey = getCriteriaList(orderedAdditionalCriteria).join('_');
    }
    return `${dataType}_${dealTypeId}_${criteriaKey}`;
}

export function getCriteriaForAssetCategory(category: AssetCategory): ICriteria {
    return {
        attribute: 'assetCategory',
        values: [category]
    };
}
